// testing
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import React, {useState} from 'react';

import {IFarmer, ISupplierUserProfile} from 'constants/interfaces';
import {
  CreateFarmerForm,
  CreateFarmerFormSubmission,
} from 'components/Farmer/CreateFarmerForm';
import {
  apiFarmerCreate,
  apiGetFarmer,
  apiUpdateFarmerAddress,
} from 'constants/Api';

export function CreateFarmerDialog(props: {
  user: ISupplierUserProfile;
  open: boolean;
  onClose: VoidFunction;
  onFarmerCreated: (farmer: IFarmer) => any;
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (submission: CreateFarmerFormSubmission) => {
    setIsLoading(true);
    apiFarmerCreate({
      username: submission.username,
      password: submission.password,
      name: submission.name,
      surname: submission.surname,
      email: submission.email,
      phone: submission.phone,
      registrationId: '',
      inviteCode: props.user.invitationCode,
      farmName: submission.farmName,
    })
      .then(async (response) => {
        if (!response.success) throw new Error(response.message);
        const farmer = await apiGetFarmer(submission.email);
        response = await apiUpdateFarmerAddress(farmer.id, {
          address: submission.address,
          latlng: submission.latlng,
          province: submission.province,
        });
        if (!response.success) throw new Error(response.message);
        return apiGetFarmer(submission.email);
      })
      .then((farmer) => {
        props.onFarmerCreated(farmer);
      })
      .then(() => handleCancel())
      .catch((err) => {
        alert(err.message);
        console.error('Error creating farmer', err);
      })
      .finally(() => setIsLoading(false));
  };

  const handleCancel = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      className="update-password-dialog"
      PaperProps={{
        style: {
          zIndex: 1300,
        },
      }}
    >
      <DialogTitle>New Customer</DialogTitle>
      <DialogContent>
        <CreateFarmerForm
          isLoading={isLoading}
          submitButtonTitle={'Create'}
          onSubmit={handleSubmit}
          cancelButtonTitle={'Cancel'}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
}
